import { render, staticRenderFns } from "./rule9.vue?vue&type=template&id=f4af96d8&scoped=true"
import script from "./rule9.vue?vue&type=script&lang=js"
export * from "./rule9.vue?vue&type=script&lang=js"
import style0 from "./rule9.vue?vue&type=style&index=0&id=f4af96d8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4af96d8",
  null
  
)

export default component.exports